





















import { Component, Vue } from "vue-property-decorator";
import * as firebase from "firebase/app";
import "firebase/auth";

@Component
export default class LogoutApp extends Vue {
  gotoLogin() {
    this.$router.push({ name: "Login" });
    localStorage.removeItem("uid");
  }

  public mounted() {
    document.title =
      "ログアウト | favsalon(ファブサロン) | 再来率を向上させるサロンに特化したネットショップサービス";
    const descriptonMeta = document.querySelector("meta[name='description']");
    if (descriptonMeta) {
      descriptonMeta.setAttribute(
        "content",
        "ログアウト | favsalon（ファブサロン）なら美容室やネイルサロン、リラクサロンなどのサロンメニューに特化したネットサロンを簡単に作ることができます。シークレットメニューで来店者のみに販売するサービスを作って再来率を向上させます！"
      );
    }
    const robotsMeta = document.querySelector("meta[name='robots']");
    if (robotsMeta) {
      robotsMeta.setAttribute("content", "noindex");
    }
    firebase
      .auth()
      .signOut()
      .then(
        () => {
          //正常系
          //ローカルストレージ初期化
          this.$store.commit("clearAuthState");
          localStorage.uid = "";
          localStorage.profileInput = "false";
          localStorage.userName = "";
        },
        () => {
          //エラー系
          //ローカルストレージ初期化
          this.$store.commit("clearAuthState");
          localStorage.uid = "";
          localStorage.profileInput = "false";
          localStorage.userName = "";
        }
      );
  }
}
